import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import tempersListService from '../services/tempers.service';
import { setMessage } from './message';
export const fetchTempersList = createAsyncThunk(
  'temper/fetchTempersList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await tempersListService.getTempersList(
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data; // Assuming response contains { data, count, totalPages, etc. }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchTemperDropdown = createAsyncThunk(
  'temper/fetchTemperDropdown',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await tempersListService.getTemperDropdown(
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data; // Assuming response contains { data, count, totalPages, etc. }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchArchivedTempersList = createAsyncThunk(
  'temper/fetchArchivedTempersList',
  async ({ page, pagesize, search }, thunkAPI) => {
    try {
      const response = await tempersListService.getArchiveTempersList(
        page,
        pagesize,
        search,
      );
      return response.data; // Assuming response contains { data, count, totalPages, etc. }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const addTemper = createAsyncThunk(
  'temper/addTempers',
  async (temperlist, thunkAPI) => {
    try {
      const data = await tempersListService.addTempers(temperlist);
      return data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const updateTemper = createAsyncThunk(
  'temper/updateTemper',
  async (temperlist, thunkAPI) => {
    try {
      const response = await tempersListService.updateTempers(temperlist.id, temperlist.updatedData);
      thunkAPI.dispatch(fetchTempersList({ page: 1, limit: 10 }));

      return response.data; // Return the updated temper list data
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const archiveTemper = createAsyncThunk(
  'temper/archiveTemper',
  async (id, thunkAPI) => {
    try {
      await tempersListService.archiveTemper(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const unArchiveTemper = createAsyncThunk(
  'temper/unArchiveTemper',
  async (id, thunkAPI) => {
    try {
      await tempersListService.unArchiveTemper(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const resetTempersListThunk = () => dispatch => {
  return new Promise(resolve => {
    dispatch(resetTempersList()); // Dispatch the synchronous action
    resolve(true); // Resolve the promise
  });
};

const initialState = {
  data: [],
  list: [],
  loading: false,
  totalpage: 0,
  currentpage: 1,
  totalRecord: 0,
  status: 'idle',
  error: null,
  hasMore: true,
};

const TempersListSlice = createSlice({
  name: 'temperlist',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetTempersList: state => {
      state.list = []; // This will clear the list
    },
    resetCurrentTemperPage: state => {
      state.currentpage = 1;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchTempersList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchTempersList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentpage;
        state.data = action.payload.results.data || []; // Adjust this to match your API response
        state.totalRecord = action.payload.count || 0;
        state.totalpage = action.payload.totalPages || 0;
        state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchTempersList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });


    builder
      .addCase(fetchTemperDropdown.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchTemperDropdown.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentpage;
        state.data = action.payload.results.data || []; // Adjust this to match your API response
        state.totalRecord = action.payload.count || 0;
        state.totalpage = action.payload.totalPages || 0;
        state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchTemperDropdown.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchArchivedTempersList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchArchivedTempersList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentpage;
        state.data = action.payload.results.data || []; // Adjust this to match your API response
        state.totalRecord = action.payload.count || 0;
        state.totalpage = action.payload.totalPages || 0;
        state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchArchivedTempersList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(addTemper.pending, state => {
        state.status = 'loading';
      })
      .addCase(addTemper.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(addTemper.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(updateTemper.pending, state => {
        state.status = 'loading';
      })
      .addCase(updateTemper.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(updateTemper.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(archiveTemper.pending, state => {
        state.status = 'loading';
      })
      .addCase(archiveTemper.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
        state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
      })
      .addCase(archiveTemper.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(unArchiveTemper.pending, state => {
        state.status = 'loading';
      })
      .addCase(unArchiveTemper.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
      })
      .addCase(unArchiveTemper.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetTempersList, resetCurrentTemperPage } = TempersListSlice.actions;
const { reducer } = TempersListSlice;
export default reducer;
